<template>
  <input
    ref="numberInput"
    type="text"
    :placeholder="placeholder"
    :tabindex="tabindex"
    @keydown="keydownHandler"
    @input="normalizeValue($event.target.value)"
  />
</template>
<script>
import { floor } from 'utils/common'
export default {
  props: {
    placeholder: [String],
    precision: {
      type: Number,
      default: 0
    },
    step: {
      type: Number
    },
    max: {
      type: Number
    },
    min: {
      type: Number,
      default: 0
    },
    tabindex: {
      type: Number
    },
    isSubmitOrder: {
      type: Boolean,
      default: false
    },
    noZero: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lastVal: 0 // 不能输入0的时候记录上次值
    }
  },
  methods: {
    focus() {
      this.$refs.numberInput.focus()
      this.$refs.numberInput.click()
    },
    normalizeValue(value) {
      // 去掉除数字和.以外的非法字符
      const numberValue = (value || '')
        .replace(/[^\d.]/g, '')
        .replace(/(^\d+\.\d*)(\.)/g, '$1')
      if (numberValue !== value) {
        this.$el.value = numberValue
      }

      const hasMoreLeading0 = /^0+\d+(?:\.\d*)?$/.test(numberValue)
      const cutValue = String(value).replace(/^0*(\d+(?:\.\d*)?)$/, '$1')

      if (hasMoreLeading0) {
        this.$el.value = cutValue
      }

      const decimal = (String(cutValue).match(/\d*\.(\d*)/) || [])[1]
      if (decimal && decimal.length > this.precision) {
        this.$el.value = floor(value, this.precision)
      }
      if (this.noZero && value === '0') {
        this.$el.value = this.lastVal
      }
      this.$emit('update', this.$el.value)
    },
    keydownHandler(event) {
      if (this.noZero) {
        this.lastVal = event.target.value
      }
      const numpadKey = event.keyCode <= 105 && event.keyCode >= 96
      const boardTopNumberKey = event.keyCode <= 57 && event.keyCode >= 48
      const numberKey = numpadKey || boardTopNumberKey
      const dotKey = event.keyCode === 190 || event.keyCode === 110
      const upKey = event.keyCode === 38
      const downKey = event.keyCode === 40
      const backspaceKey = event.keyCode === 8
      const tabKey = event.keyCode === 9
      const enterKey = event.keyCode === 13
      const leftKey = event.keyCode === 37
      const rightKey = event.keyCode === 39
      const isDirection = upKey || downKey || leftKey || rightKey

      if (
        !numberKey &&
        !isDirection &&
        !dotKey &&
        !backspaceKey &&
        !tabKey &&
        !enterKey
      ) {
        event.preventDefault()
      }
      if (leftKey || rightKey) {
        event.stopPropagation()
      }

      const dotInvalid = this.precision <= 0 || event.target.value.includes('.')
      if (dotKey && dotInvalid) {
        event.preventDefault()
      }

      if (upKey) {
        event.stopPropagation()
        event.preventDefault()
        this.increase()
        this.$nextTick(() => {
          this.focusEnd()
        })
        return
      } else if (downKey) {
        event.stopPropagation()
        return this.decrease()
      }

      if (this.isSubmitOrder && enterKey) {
        this.$emit('submitOrder')
      }
    },
    focusEnd() {
      const inpEl = this.$refs.numberInput
      inpEl.focus()
      const length = inpEl.value.length
      if (document.selection) {
        const range = inpEl.createTextRange()
        range.moveStart('character', length)
        range.collapse()
        range.select()
      } else if (
        typeof inpEl.selectionStart === 'number' &&
        typeof inpEl.selectionEnd === 'number'
      ) {
        inpEl.selectionStart = inpEl.selectionEnd = length
      }
    },
    increase() {
      if (!this.step) return

      const value = Number(this.$el.value) + this.step
      if (typeof this.max === 'number' && value > this.max) {
        return
      }
      this.update(value)
    },
    decrease() {
      if (!this.step) return

      const value = Number(this.$el.value) - this.step
      if (value <= this.min) {
        return
      }
      this.update(value)
    },
    update(value) {
      if (this.noZero) {
        this.lastVal = value
      }
      // type是text，不需要转数字，否则会丢失末尾0小数部分
      this.$el.value = value
      this.$emit('update', value)
    }
  }
}
</script>
